import { createApiInstance } from './config'

const gameConstantsAPI = createApiInstance()

export default {
  // 获取常量列表
  getConstants(game = '尤弥尔传奇国际服') {
    return gameConstantsAPI.get('/game-constants/list', {
      params: { game }
    })
  },
  
  // 保存常量（创建或更新）
  saveConstant(data) {
    return gameConstantsAPI.post('/game-constants/save', data)
  },
  
  // 删除常量
  deleteConstant(game, gameKey) {
    return gameConstantsAPI.delete('/game-constants/delete', {
      params: { game, gameKey }
    })
  }
}

